"use client";

interface EmbeddedEventMapProps {
  latitude: number;
  longitude: number;
  venueName?: string | null;
  className?: string;
}

/**
 * Displays an embedded Google Maps iframe using the Embed API (FREE, unlimited usage)
 * Uses coordinates or falls back to address-based embedding
 */
export function EmbeddedEventMap({
  latitude,
  longitude,
  venueName,
  className = "",
}: EmbeddedEventMapProps) {
  // Google Maps Embed API - FREE and unlimited
  // Format: https://www.google.com/maps/embed/v1/place?key=API_KEY&q={LAT},{LNG}
  // Note: API key should be restricted by HTTP referrer in Google Cloud Console
  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_EMBED_API_KEY || "";
  
  if (!apiKey) {
    // Fallback: Use Google Maps link (no API key needed, but no embedded map)
    const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    return (
      <div className={`w-full ${className}`}>
        <a
          href={mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full h-48 bg-gray-200 rounded-lg flex items-center justify-center text-sm text-gray-600 hover:bg-gray-300 transition-colors"
        >
          View on Google Maps
        </a>
      </div>
    );
  }

  const embedUrl = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${latitude},${longitude}`;

  return (
    <div className={`w-full ${className}`}>
      <iframe
        width="100%"
        height="300"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        src={embedUrl}
        title={venueName ? `Map location for ${venueName}` : "Event location map"}
        className="rounded-lg"
      />
    </div>
  );
}




